import React from 'react'

import { getTranslate } from '../../utilities/i18n'
import LinkWithQueryForwarding from '../button/LinkWithQueryForwarding'
import Icon from '../icons/Icon'

type Props = {
  readonly link: string
  readonly topic: string
  readonly iconName: string
}

const MenuCard: React.FC<Props> = ({ link, topic, iconName }) => {
  const { t } = getTranslate()

  return (
    <LinkWithQueryForwarding href={link} className="flex w-full self-stretch hover:no-underline">
      <div className="relative w-full self-stretch rounded-xl bg-white p-6 shadow-hedepy tablet:p-6 tablet:pb-14">
        <div className="flex">
          <div className="mb-4 shrink rounded-xl bg-body-bg">
            <Icon className="m-2" icon={iconName} size="slg" />
          </div>
        </div>
        <h2 className="font-sans text-sm uppercase text-text-color big-phone:text-lg">
          {t(`component.premiumContent.${topic}.title`)}
        </h2>
        <div className="pb-8 text-sm text-text-color big-phone:text-base">
          {t(`component.premiumContent.${topic}.subtitle`)}
        </div>
        <div className="absolute inset-x-0 bottom-6 text-right">
          <Icon icon="arrow" size="md" className="mr-6" />
        </div>
      </div>
    </LinkWithQueryForwarding>
  )
}

export default MenuCard
